import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { productSchema } from './schemas';

export const productsQueryOptions = queryOptions({
  queryKey: QueryKeys.products.index,
  queryFn: async () => {
    const { data: products } = await fetchJson('/products', {
      schema: apiResourceSchema(productSchema.array()),
    });

    return products;
  },
  staleTime: 60 * 1000,
  gcTime: Infinity,
});

export const useProducts = () => {
  return useSuspenseQuery(productsQueryOptions);
};
